<template>
    <section>
        <!-- Account Holder Summary -->
        <div v-if="!displayProfileUpdateForm && userDetails.whmcs_contact_id">
            <div v-if="!gotData">
                <sau-loading>
                    <template slot="message">Fetching Account Holder Details</template>
            </sau-loading>
            </div>
            <div v-else>
                <h3>Account Holder</h3>
                <div class="sau-bx p-6">
                    <div class="row">
                        <div class="col-lg-3 text-center">
                            <img :src="accountHolder.avatar" height="130" width="130" class="sau-avatar md bdr-gray md mx-auto mb-1">
                            <h5 class="text-center sau-para-m">{{ accountHolder.firstname }} {{ accountHolder.lastname }}</h5>
                            <p class="sau-font xs">Your image by <a href="https://en.gravatar.com/" target="_blank">Gravatar</a> <span class="sau-help sm align-middle" v-b-tooltip title="We use your uploaded Gravatar image or a Gravatar unique image based on your email">?</span></p>
                        </div>
                        <div class="col-lg-9">
                            <ul class="sau-list-display text-left text-lg-left">
                                <li>
                                    <h5>Email</h5>
                                    <p>{{ accountHolder.email }}</p>
                                </li>
                                <li>
                                    <h5>Address</h5>
                                    <!-- <i v-if="!accountHolderFeatures.hasOwnProperty('confirmed-address')" class="far fa-exclamation-circle"></i> -->
                                    <!-- <a href="#" v-if="!accountHolderFeatures.hasOwnProperty('confirmed-address')" @click.prevent="editAccountHolderProfile()" class="sau-font sm sau-linx green">{{ canEditAccountHolder ? 'Please verify address' : 'address not verified'}}</a> -->
                                    <p>{{ accountHolder.address1 }}, {{ accountHolder.address2 ? accountHolder.address2 + ', ' : '' }} {{ accountHolder.city }} {{ accountHolder.state }} {{ accountHolder.postcode }}</p>
                                </li>
                                <li>
                                    <h5>Account Password</h5>
                                    <!-- <p v-if="accountHolder.account_pin">{{ accountHolder.account_pin }}</p> -->

                                    <template v-if="userDetails.account_pin">
                                        <div v-show="!showAccessPassword">
                                            <!-- Match the dots to the password length -->
                                            <span class="sau-pwd-dot space" v-for="(key, index) in userDetails.account_pin.length" :key="index"></span>
                                            <span class="sau-help sm ml-2 align-middle" v-b-tooltip.hover :title="popup">?</span>
                                            <a href="#" class="sau-linx green sau-font sm pl-2" @click.prevent="showAccessPassword = !showAccessPassword">Show</a>
                                        </div>
                                        <div v-show="showAccessPassword">
                                            <span class="clear-password wm-hide">{{ userDetails.account_pin }}</span> <span class="sau-help sm ml-2 align-middle" v-b-tooltip.hover :title="popup">?</span>
                                            <a href="#" class="sau-linx green sau-font sm pl-2" @click.prevent="showAccessPassword = !showAccessPassword">Hide</a>
                                        </div>
                                    </template>

                                    <i v-if="!userDetails.account_pin" class="far fa-exclamation-circle"></i>
                                    <a href="#" v-if="!userDetails.account_pin" @click.prevent="setupPIN()" class="sau-font sm sau-linx green">{{ canEditAccountHolder ? 'Set up account verification password' : 'Not Set'}}</a>

                                </li>
                                <li>
                                    <h5>Client ID</h5>
                                    {{ userDetails.whmcs_client_id }}:{{ userDetails.whmcs_contact_id }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="!displayProfileUpdateForm && canEditAccountHolder">
                    <div class="col text-lg-right">
                        <a href="#" @click.prevent="editAccountHolderProfile()" class="sau-font sm sau-linx green">Update account holder profile</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Your Profile -->
        <div class="row pt-6" v-if="!displayProfileUpdateForm">
            <div class="col">
                <h3>Your profile</h3>
                <div class="sau-bx p-6">
                    <div class="row">
                        <div class="col-lg-3 text-center">
                            <img :src="userDetails.avatar" height="130" width="130" class="sau-avatar md bdr-gray md mx-auto mb-1">
                            <h5 class="text-center sau-para-m">{{ userDetails.firstname }} {{ userDetails.lastname }}</h5>
                            <p class="sau-font xs">Your image by <a href="https://en.gravatar.com/" target="_blank">Gravatar</a> <span class="sau-help sm align-middle" v-b-tooltip title="We use your uploaded Gravatar image or a Gravatar unique image based on your email">?</span></p>
                        </div>
                        <div class="col-lg-9">
                            <h5>Contact Details</h5>
                            <p class="mb-0"><strong>Company:</strong> {{ userDetails.companyname }}</p>
                            <p class="mb-0" v-if="! isContact"><strong>ABN:</strong> {{ abn }}</p>
                            <p class="mb-0"><strong>Address:</strong> <span v-html="formattedAddress"></span></p>
                            <p class="mb-0"><strong>Phone:</strong> {{ userDetails.phonenumber }}</p>
                            <p class="mb-0"><strong>Email:</strong> {{ userDetails.email }}</p>

                            <ul class="sau-list-display text-left text-lg-left mt-3 border-top" v-if="!userDetails.whmcs_contact_id">
                                <li>
                                    <h5>Account Password</h5>
                                    <p v-if="userDetails.account_pin">{{ userDetails.account_pin }}<span class="sau-help sm ml-2 align-middle" v-b-tooltip.hover :title="popup">?</span></p>
                                    <i v-if="!userDetails.account_pin" class="far fa-exclamation-circle"></i>
                                    <a href="#" v-if="!userDetails.account_pin" @click.prevent="setupPIN()" class="sau-font sm sau-linx green">{{ 'Set up account verification password' }}</a>
                                </li>
                                <li>
                                    <h5>Client ID</h5>
                                    {{ userDetails.whmcs_client_id }}<template v-if="userDetails.whmcs_contact_id != 0">:{{ userDetails.whmcs_contact_id }}></template>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="!displayProfileUpdateForm">
            <div class="col text-lg-right">
                <button class="btn btn-success font-bold mt-3" @click.prevent="$store.commit('setDisplayProfileUpdateForm', true)">View and Edit Details</button>
            </div>
        </div>

        <!-- Update Profile Form -->
        <div class="row" v-if="displayProfileUpdateForm">
            <div class="col">
                <sau-account-update></sau-account-update>
            </div>
        </div>

    </section>
</template>

<script>
export default {
    data() {
        return {
            showAccessPassword: false,
            canEditAccountHolder: false,
            popup: "To protect your privacy, we may ask for your Account Password when contacting us by phone to validate who you are. This can be updated under the 'Security' tab",
            abn: '',
        }
    },
    computed:{
        formattedAddress() {
            let address = [this.userDetails.address1, this.userDetails.address2, this.userDetails.city, this.userDetails.state, this.userDetails.postcode];
            let filtered = address.filter((item) => item != '');
            return filtered.length ? filtered.join(', ') : 'Not set';
        },
        isContact() {
            return this.userDetails.whmcs_contact_id != 0;
        },
    },
    mounted() {
        this.canEditAccountHolder = this.userDetails.whmcs_contact_id ? this.userDetails.permissions.split(",").indexOf('profile') > -1 : true;

        if(! this.isContact) {
            this.getClientCustomFields()
                .then(({ data }) => {
                    this.abn = data.find((customField) => customField.fieldname.toLowerCase() === 'abn').value;
                });
        }
    },
    created() {
        if(!Object.keys(this.accountHolder).length > 0) {
            this.startApp();
        } else {
            this.gotData = true;
        }
        /** check if url contains /edit - flag displayProfileUpdateForm */
        if(window.location.href.indexOf('edit') > -1){
            this.$store.commit('setDisplayProfileUpdateForm', true);
        }
    },
    methods: {
        startApp() {
            this.getAccountHolder().then(response => {
                this.$store.commit('setAccountHolder', response.data);
            });
        },
        editAccountHolderProfile() {
            if(this.canEditAccountHolder){
                this.$store.commit('setIsEditingAccountHolderProfile', true)
                this.$store.commit('setDisplayProfileUpdateForm', true)
            }
        },
        setupPIN(){
            if(this.canEditAccountHolder){
                window.location = '/account/security';
            } else {
                this.$swal({
                    type:'info',
                    title: 'You do not have permission to update the account password',
                    showConfirmButton: false,
                    timer: 5000
                });
            }
        }
    }
}
</script>
<style>
.space {
    margin:0px 2px;
}
</style>
